const REACT_APP_API =
  window.REACT_APP_API || "https://api.dev.fairregister.net/api-service";
const KEYCLOAK_URL =
  window.KEYCLOAK_URL || "https://id.fairkom.net/auth";
const KEYCLOAK_REALM =
  window.KEYCLOAK_REALM || "fairlogin";
const KEYCLOAK_CLIENT_ID =
  window.KEYCLOAK_CLIENT_ID || "fairregister-development";

export { REACT_APP_API, KEYCLOAK_URL, KEYCLOAK_REALM, KEYCLOAK_CLIENT_ID };
